import React, { useEffect, useRef, useState } from "react";
import { Checkbox, Input } from "antd";
import { CaretDownOutlined, HolderOutlined } from "@ant-design/icons";
import { FieldsUpdate, IField, ListField, updateFieldUser } from "../../../api/Customer_V2/customerApi_V2";
import { useSelector } from "react-redux";
import { selectorInfoUser } from "../../../store/slices/infoUserSlice";
import { FIELDTYPE } from "../../../services/data";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import { FlattenedField } from "../indexV2";

interface Props {
  isSettingShow: boolean
  type?: 0 | 1
  dataFilterActive: FlattenedField[]
  dataFilterNoActive: ListField[]
  gListCustomerFields?: (value?: string) => void;
  onSaveDataFields: (iSsuccess?: boolean, message?: string, dataFilterActive?: FlattenedField[], dataFilterNoActive?: ListField[]) => void;
  onClose?: () => void;
}



const CustomerFeildsGroup: React.FC<Props> = ({
  isSettingShow, type = 0, dataFilterActive, dataFilterNoActive,
  onClose,
  onSaveDataFields,
  gListCustomerFields,
}) => {
  const { id } = useSelector(selectorInfoUser)
  const [isMore, setMore] = useState(false)

  const popupRef = useRef<HTMLDivElement>(null);
  const [searchValue, setSearchValue] = useState("");
  const [idSelect, setIdSelect] = useState<number>()
  const [dataFilterActiveTmp, setDataFilterActiveTmp] = useState<FlattenedField[]>([])
  const [dataFilterNoActiveTmp, setDataFilterNoActiveTmp] = useState<ListField[]>([])

  const uFieldUser = async () => {
    const activeFields: FieldsUpdate[] = dataFilterActiveTmp.map(item => ({
      fieldId: item.id,
      isActive: 1, // hoặc true tùy bạn muốn mặc định là gì
    }));

    const allFieldsDefaultInactive: FieldsUpdate[] = dataFilterNoActiveTmp.flatMap(group =>
      group.fields.map(field => ({
        fieldId: field.id,
        isActive: 0,
      }))
    );

    const result = await updateFieldUser(id, FIELDTYPE.CustomerInGroup, type, activeFields.concat(allFieldsDefaultInactive))
    if (result?.status) {
      onSaveDataFields(result.status, result.message, dataFilterActiveTmp, dataFilterNoActiveTmp);
    } else {
      onSaveDataFields(result.status, result.message,);
    }
  }

  const handleOnDragEnd = (result: any) => {
    if (!result.destination) return;

    const items = Array.from(dataFilterActiveTmp);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setDataFilterActiveTmp(items)
  };

  const handleCheckboxChange = (parentId: number, fieldId: number, isChecked: boolean) => {
    if (isChecked) {
      // 1. Lấy nhóm field theo parentId
      const parentGroup = dataFilterNoActiveTmp.find(group => group.id === parentId);
      if (!parentGroup) return;

      // 2. Lấy field con theo id
      const selectedField = parentGroup.fields.find(field => field.id === fieldId);
      if (!selectedField) return;

      // 3. Tạo bản sao FlattenedField để thêm vào danh sách đã chọn
      const fieldWithParent: FlattenedField = { ...selectedField, parentId };

      // 4. Xóa field khỏi danh sách dataFilterNoActiveTmp
      setDataFilterNoActiveTmp(prevFields =>
        prevFields.map(group => ({
          ...group,
          fields: group.fields.filter(field => field.id !== fieldId)
        }))
      );

      // 5. Thêm vào danh sách đã chọn
      setDataFilterActiveTmp(prev => [...prev, fieldWithParent]);

    } else {
      // 1. Xoá field khỏi danh sách đã chọn
      const removedField = dataFilterActiveTmp.find(field => field.id === fieldId);
      if (!removedField) return;

      setDataFilterActiveTmp(prev => prev.filter(field => field.id !== fieldId));

      // 2. Chuyển về định dạng IField để thêm lại vào dataFilterNoActiveTmp
      const restoredField: IField = {
        id: removedField.id,
        fieldCode: removedField.fieldCode,
        fieldLabel: removedField.fieldLabel,
        inputType: removedField.inputType
      };

      // 3. Thêm lại vào nhóm phù hợp trong dataFilterNoActiveTmp
      setDataFilterNoActiveTmp(prevFields =>
        prevFields.map(group => {
          if (group.id === parentId) {
            return {
              ...group,
              fields: [...group.fields, restoredField]
            };
          }
          return group;
        })
      );
    }
  };

  useEffect(() => {
    const handleOutsideClick = (e: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(e.target as Node)) {
        onClose?.();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [onClose]);

  useEffect(() => {
    if (isSettingShow) {
      setDataFilterActiveTmp(dataFilterActive)
      setDataFilterNoActiveTmp(dataFilterNoActive)
    }
  }, [isSettingShow])
  return (
    <div ref={popupRef} className="filter-setting">
      <div className="title-add-filter">
        <span>Nâng cao</span>
      </div>
      <div className="content-filter-setting t-scrollbar">
        <div className="title-content">Tùy chỉnh trường hiển thị trên bảng</div>
        <div style={{ marginBottom: 12 }}>
          <Input
            placeholder="Tìm kiếm theo tên cột"
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
            }}
            allowClear
          />
        </div>
        <div className="list-add-filter-content">
          {/* thêm dropdown show */}
          <div
            className={`relative-collapse__title ${(isMore === true || searchValue.length) ? 'show' : 'collapsed'}`}
            onClick={() => setMore(!isMore)}
          >
            <div
              className="icon"
            >
              <CaretDownOutlined />
            </div>
            <div className="title ">
              <span className="font-bold neutral-gray-700">
                Đang hiển thị
              </span>
            </div>
          </div>
          <div className={(isMore || searchValue.length) ? 'pt-2' : 'd-none'} >
            <DragDropContext onDragEnd={handleOnDragEnd}>
              <Droppable droppableId="menu">
                {(provided) => (
                  <ul
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    className="drag-drop-content customer-head-list-setting"
                  >
                    {dataFilterActiveTmp
                      .filter((item: FlattenedField) =>
                        item.fieldLabel.toLowerCase().includes(searchValue.toLowerCase())
                      ).map((item, index) => (
                        <Draggable
                          key={item.id}
                          draggableId={item.id.toString()}
                          index={index}
                        >
                          {(provided) => (
                            <li
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              className={`one-op active`}
                            >
                              <HolderOutlined className="icon" />
                              <div className="text">
                                <Checkbox
                                  className="one-add-filter-content"
                                  defaultChecked={true}
                                  onChange={(e) =>
                                    handleCheckboxChange(item.parentId, item.id, e.target.checked)
                                  }
                                >
                                  <div className="label">{item.fieldLabel}</div>
                                </Checkbox>
                              </div>
                            </li>
                          )}
                        </Draggable>
                      ))}
                    {provided.placeholder}
                  </ul>
                )}
              </Droppable>
            </DragDropContext>
          </div>
          <div className={`relative-collapse`}>
            {
              dataFilterNoActiveTmp?.map((item, i) => {
                if (item?.fields?.length === 0) return null;
                return (
                  <div
                    key={i}
                  >
                    <div
                      className={`relative-collapse__title ${idSelect === item.id ? 'show' : 'collapsed'}`}
                    >
                      <div
                        className="icon"
                        onClick={() => setIdSelect(item.id === idSelect ? undefined : item.id)}
                      >
                        <CaretDownOutlined />
                      </div>
                      <div className="title ">
                        <span className='font-bold neutral-gray-700'>{item.title}</span>
                      </div>
                    </div>
                    <div
                      className={`relative-collapse__content ${(idSelect === item.id || searchValue.length) ? 'show' : 'collapsed'}`}
                    >
                      {
                        item.fields
                          .filter((itemChild) =>
                            itemChild.fieldLabel.toLowerCase().includes(searchValue.toLowerCase())
                          ).map((itemChild, i) => (
                            <Checkbox
                              key={i}
                              className="one-add-filter-content d-flex gap-2 align-center"
                              checked={!item.id}
                              defaultChecked={false}
                              onChange={(e) =>
                                handleCheckboxChange(item.id, itemChild.id, e.target.checked)
                              }
                            >
                              <div className="label">{itemChild.fieldLabel}</div>
                            </Checkbox>
                          ))
                      }
                    </div>
                  </div>
                )
              })
            }

          </div>
        </div>
      </div>
      <div className="footer-filter-block">
        <div className="btn-block">
          <div className="btn btn-primary"
            onClick={uFieldUser}
          >
            <div className="text">Lưu</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerFeildsGroup;
